import { Route, Routes } from "react-router-dom";
import { Tabs } from "./pages/Tabs";


function Router() {
  return (
    <Routes>
      <Route path="/" element={<Tabs />} />
    </Routes>
  )
}

export default Router;